/**
 * One live-connection probe per connectable source, used by Settings'
 * "Probar conexión" and by `fetchSourceConnectionStatus` (an empty, idle,
 * error-free feed probes to distinguish "never configured" from "provider
 * rejected the credential"). Adding a provider means adding one entry here.
 */

import type { ApiEnvelope } from '../domain/types';
import type { ConnectableSource } from '../domain/providerIds';
import { gitHubClient, gmailClient, jiraClient, slackClient } from './clients';

export type ProbeEnvelope = ApiEnvelope<{
  status: unknown;
  error?: unknown;
  message?: unknown;
}>;

export const PROVIDER_PROBES: Record<ConnectableSource, () => Promise<ProbeEnvelope>> = {
  jira: () => jiraClient.testConnection(),
  github: () => gitHubClient.testConnection(),
  slack: () => slackClient.testConnection(),
  gmail: () => gmailClient.testConnection(),
};
